import { paymentBoundaryTitle, paymentRangeTitle } from 'src/utils/filters.js';
import { getSsrState } from 'src/utils/ssr.js';
import { createVueApp } from 'src/utils/vue.js';

import ExpertsListPage from 'src/components/experts/ExpertsListPage/ExpertsListPage.vue';
import FiltersProvider from 'src/components/filters/FiltersProvider/FiltersProvider.vue';
import VisitorProvider from 'src/components/users/VisitorProvider/VisitorProvider.vue';

import 'styles/views/shared/sidebar/best_companies.css.sass';
import 'styles/parts/forms.css.sass';

const models = {
  currency: {
    default: 'rur',
    isSelected: () => false,
  },
  freeOnly: {
    title: 'Бесплатно',
  },
  companies: {
    title: ({ filters, title }) => {
      if (filters.excludeCompany && filters.isCurrentCompany) {
        return `${title} (не текущее место работы)`;
      }
      if (filters.excludeCompany) {
        return `${title} (исключить)`;
      }
      if (filters.isCurrentCompany) {
        return `${title} (текущее место работы)`;
      }
      return title;
    },
  },
  excludeCompany: {
    isSelected: () => false,
  },
  isCurrentCompany: {
    isSelected: () => false,
  },
  freeIntro: {
    title: 'Первая встреча бесплатно',
  },
  rateFrom: {
    title: paymentRangeTitle('rateFrom', 'rateTo'),
    partOf: ['rateTo'],
  },
  rateTo: {
    title: paymentBoundaryTitle('to'),
    isSelected: ({ items }) => {
      return items.rateFrom === null;
    },
  },
  qid: {
    optionsKey: 'qualifications',
  },
  rid: {
    optionsKey: 'requestGroups',
  },
  sid: {
    optionsKey: 'specializations',
  },
};

const {
  isGuest,
  currentUserAlias,
  expertConnections,
  activeConnections,
  visibleFeedbackForm: showFeedbackBlock,
  // параметры поиска
  search,
  // статичные справочники
  options,
  // модели для селектов с поиском, у которых опции подтягиваются в зависимости от запроса
  filtersData: dynamicOptions,
  // список экспертов и пагинация
  experts,
  showBillingBanner,
} = getSsrState();
/**
 * Ключи в filters должны совпадать с клчючами в options,
 * хотя бы для фильтров, которые используют options и dynamicOptions.
 * Это нужно для работы SelectedFilters, который опирается на опции для
 * отображения выбранных фильтров.
 */
const { q: query, order, filters } = search;

// Мапим специализации, чтобы было удобнее
options.groups = [];
options.specializations = [];
options.specializationGroups.forEach((group) => {
  options.groups.push(group);
  group.children.forEach((spec) => {
    // eslint-disable-next-line no-param-reassign
    spec.value = spec.id;
  });
  options.specializations.push(...group.children);
});

delete options.specializationGroups;

filters.specializations = filters.specializationGroups;

const app = createVueApp({
  render(h) {
    return h(
      VisitorProvider,
      { props: { visitor: { isGuest, alias: currentUserAlias } } },
      [
        h(
          FiltersProvider,
          {
            props: {
              filters,
              options,
              dynamicOptions,
              models,
            },
          },
          [
            h(ExpertsListPage, {
              props: {
                experts,
                query,
                order,
                expertConnections,
                activeConnections,
                showFeedbackBlock,
                showBillingBanner,
              },
            }),
          ],
        ),
      ],
    );
  },
});

app.$mount('[data-experts-list]');
